import { useMemo } from 'react'

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteService } from 'src/lib/sante-api/services'

import { FETCH_SERVICES_QUERY_KEY } from './useFetchServicesQuery'

/**
 * @param {import('src/types/sante-api').FetchServicesParams} params
 * @param {import('@tanstack/react-query').UseMutationOptions} options
 */
export function useDeleteServiceMutation(params = {}, options = {}) {
  const queryClient = useQueryClient()

  const queryKey = useMemo(() => [FETCH_SERVICES_QUERY_KEY, params], [params])

  return useMutation({
    ...(options ?? {}),

    mutationFn: (item) => deleteService(item.id),

    onMutate: async (item) => {
      await queryClient.cancelQueries({ queryKey })

      const previous = queryClient.getQueryData(queryKey)

      queryClient.setQueryData(queryKey, (old) => old.filter((oldItem) => oldItem.id !== item.id))

      return { previous }
    },

    onError: (err, variables, context) => {
      if (context?.previous) queryClient.setQueryData(queryKey, context.previous)

      if (options?.onError) options.onError(err, variables, context)
    },

    onSettled: (data, error, variables, context) => {
      queryClient.invalidateQueries({ queryKey })

      if (options?.onSettled) options.onSettled(data, error, variables, context)
    },
  })
}
